import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fill="#D0D6CE"
      fillRule="evenodd"
      d="M4.722 7.84a6.5 6.5 0 0 1 12.133-2.528A4.85 4.85 0 1 1 17.183 15H5.6a3.633 3.633 0 0 1-.879-7.16"
      clipRule="evenodd"
    />
    <path
      fill="#A180D3"
      d="M8 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12 19a1 1 0 1 1-2 0 1 1 0 0 1 2 0M16 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 21a1 1 0 1 1-2 0 1 1 0 0 1 2 0M15 22a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
  </>
);

const Weather41Colored = Icon('weather-41-colored', svgContents);

export default Weather41Colored;
